import React, { useState } from "react";
import {
  AppBar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import HomeIcon from "@mui/icons-material/Home";
import GroupIcon from "@mui/icons-material/Group";
import AssessmentIcon from "@mui/icons-material/Assessment";
import SettingsIcon from "@mui/icons-material/Settings";
import { useLocation, useNavigate } from "react-router-dom";
import { theme } from "../../Assets/Theme/theme";
import logo from "../../Assets/Images/logo.png";
import person from "../../Assets/Images/person.png";
import ExploreIcon from "@mui/icons-material/Explore";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import InsertInvitationOutlinedIcon from "@mui/icons-material/InsertInvitationOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import InsertChartOutlinedOutlinedIcon from "@mui/icons-material/InsertChartOutlinedOutlined";
import QrCodeIcon from "@mui/icons-material/QrCode";
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

const sidebarItems = [
  { id: 1, label: "Dashboard", icon: <HomeIcon />, path: "/admin/dashboard" },
  { id: 2, label: "Users", icon: <GroupIcon />, path: "/admin/users" },
  {
    id: 3,
    label: "Experiences",
    icon: <ExploreIcon />,
    path: "/admin/experiences",
  },
  {
    id: 16,
    label: "Tickets",
    icon: <ConfirmationNumberIcon />,
    path: "/admin/tickets",
  },
  {
    id: 17,
    label: "Dates",
    icon: <CalendarTodayIcon />,
    path: "/admin/date",
  },
  {
    id: 9,
    label: "Bookings",
    icon: <InsertInvitationOutlinedIcon />,
    path: "/admin/booking",
  },
  {
    id: 4,
    label: "Analytics",
    icon: <AssessmentIcon />,
    path: "/admin/analytics",
  },
  {
    id: 5,
    label: "Payments",
    icon: <PaymentsOutlinedIcon />,
    path: "/admin/payments",
  },
  {
    id: 10,
    label: "Barcode",
    icon: <QrCodeIcon />,
    path: "/admin/barcode",
  },
  { id: 6, label: "Settings", icon: <SettingsIcon />, path: "/admin/settings" },
  { id: 7, label: "Logout", icon: <LogoutOutlinedIcon />, path: "/login" },
];

const Sidebar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [openLogoutDialog, setOpenLogoutDialog] = useState(false);


  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleLogout = () => {
    localStorage.removeItem("adminData");
    navigate("/login");
    setOpenLogoutDialog(false);
  };

  const handleLogoutClick = () => {
    setOpenLogoutDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenLogoutDialog(false);
  };

  const drawerContent = (
    <Box style={{ flex: 1 }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "16px 0",
          cursor: 'pointer'
        }}
        onClick={() => navigate('/admin/dashboard')}
      >
        <img
          src={logo}
          alt="Logo"
          style={{ width: "120px", marginBottom: "8px" }}
        />
      </Box>
      <Typography
        variant="h6"
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
        fontWeight={700}
        my={3}
      >
        <img
          src={person}
          alt="Person"
          style={{ fontSize: 30, position: "relative", right: 10 }}
        />
        Admin
      </Typography>
      <List>
        {sidebarItems.map((item) => (
          <ListItem
            button
            key={item.id}
            onClick={(event) => {
              if (event.ctrlKey || event.metaKey) {
                window.open(item.path, '_blank');
              } else if (item.label === "Logout") {
                handleLogoutClick();
              } else {
                navigate(item.path);
              }
            }}
            
            sx={{
              cursor: "pointer",
              display: "flex",
              backgroundColor:
                location.pathname === item.path ||
                (location.pathname.includes("/experience/add") &&
                  item.path === "/admin/experiences") ||
                (location.pathname.includes("/experience/edit") &&
                  item.path === "/admin/experiences") || 
                  (location.pathname.includes("/tickets/add") &&
                  item.path === "/admin/tickets") || 
                  (location.pathname.includes("/tickets/edit") &&
                  item.path === "/admin/tickets") || 
                  (location.pathname.includes("/date/add") &&
                  item.path === "/admin/date") || 
                  (location.pathname.includes("/date/edit") &&
                  item.path === "/admin/date") ||
                (location.pathname.includes("/barcode/add") &&
                  item.path === "/admin/barcode") ||
                (location.pathname.includes("/barcode/edit") &&
                  item.path === "/admin/barcode") ||
                (location.pathname.includes("/edit-user") &&
                  item.path === "/admin/users")
                  ? "#fff"
                  : "transparent",
              color:
                location.pathname === item.path ||
                (location.pathname.includes("/experience/add") &&
                  item.path === "/admin/experiences") ||
                (location.pathname.includes("/experience/edit") &&
                  item.path === "/admin/experiences") ||
                  (location.pathname.includes("/tickets/add") &&
                  item.path === "/admin/tickets") || 
                  (location.pathname.includes("/tickets/edit") &&
                  item.path === "/admin/tickets") || 
                  (location.pathname.includes("/date/add") &&
                  item.path === "/admin/date") || 
                  (location.pathname.includes("/date/edit") &&
                  item.path === "/admin/date") ||
                (location.pathname.includes("/barcode/add") &&
                  item.path === "/admin/barcode") ||
                (location.pathname.includes("/barcode/edit") &&
                  item.path === "/admin/barcode") ||
                (location.pathname.includes("/edit-user") &&
                  item.path === "/admin/users")
                  ? theme.colors.orange
                  : "#fff",
              // borderRadius: "8px",
              marginY: "4px",
              width: "100%",
              "&:hover":
                location.pathname === item.path ||
                (location.pathname.includes("/experience/add") &&
                  item.path === "/admin/experiences") ||
                (location.pathname.includes("/experience/edit") &&
                  item.path === "/admin/experiences") ||
                  (location.pathname.includes("/tickets/add") &&
                  item.path === "/admin/tickets") || 
                  (location.pathname.includes("/tickets/edit") &&
                  item.path === "/admin/tickets") || 
                  (location.pathname.includes("/date/add") &&
                  item.path === "/admin/date") || 
                  (location.pathname.includes("/date/edit") &&
                  item.path === "/admin/date") || 
                (location.pathname.includes("/barcode/add") &&
                  item.path === "/admin/barcode") ||
                (location.pathname.includes("/barcode/edit") &&
                  item.path === "/admin/barcode") ||
                (location.pathname.includes("/edit-user") &&
                  item.path === "/admin/users")
                  ? { background: "#fff" }
                  : {
                      backgroundColor: "rgba(255, 255, 255, 0.1)",
                    },
            }}
          >
            <ListItemIcon
              sx={{
                color:
                  location.pathname === item.path ||
                  (location.pathname.includes("/experience/add") &&
                    item.path === "/admin/experiences") ||
                  (location.pathname.includes("/experience/edit") &&
                    item.path === "/admin/experiences") ||
                    (location.pathname.includes("/tickets/add") &&
                    item.path === "/admin/tickets") || 
                    (location.pathname.includes("/tickets/edit") &&
                    item.path === "/admin/tickets") || 
                    (location.pathname.includes("/date/add") &&
                    item.path === "/admin/date") || 
                    (location.pathname.includes("/date/edit") &&
                    item.path === "/admin/date") || 
                  (location.pathname.includes("/barcode/add") &&
                    item.path === "/admin/barcode") ||
                  (location.pathname.includes("/barcode/edit") &&
                    item.path === "/admin/barcode") ||
                  (location.pathname.includes("/edit-user") &&
                    item.path === "/admin/users")
                    ? theme.colors.orange
                    : "#fff",
              }}
            >
              {item.icon}
            </ListItemIcon>
            <ListItemText
              primary={item.label}
              sx={{
                fontWeight:
                  location.pathname === item.path ||
                  (location.pathname.includes("/experience/add") &&
                    item.path === "/admin/experiences") ||
                  (location.pathname.includes("/experience/edit") &&
                    item.path === "/admin/experiences") ||
                    (location.pathname.includes("/tickets/add") &&
                    item.path === "/admin/tickets") || 
                    (location.pathname.includes("/tickets/edit") &&
                    item.path === "/admin/tickets") || 
                    (location.pathname.includes("/date/add") &&
                    item.path === "/admin/date") || 
                    (location.pathname.includes("/date/edit") &&
                    item.path === "/admin/date") || 
                  (location.pathname.includes("/barcode/add") &&
                    item.path === "/admin/barcode") ||
                  (location.pathname.includes("/barcode/edit") &&
                    item.path === "/admin/barcode") ||
                  (location.pathname.includes("/edit-user") &&
                    item.path === "/admin/users")
                    ? "bold"
                    : "normal",
              }}
            />
          </ListItem>
        ))}
      </List>
      <Dialog
        open={openLogoutDialog}
        onClose={handleCloseDialog}
        aria-labelledby="logout-dialog-title"
      >
        <DialogTitle id="logout-dialog-title">Alert</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Do you really want to log out?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={handleCloseDialog} color="primary">
            Cancel
          </Button> */}
           <Button onClick={handleCloseDialog} color="black" sx={{
              backgroundColor: theme.colors.lightGrey,
              borderRadius: '5px',
              color: 'grey',
              '&:hover': {
                backgroundColor: '#A9A9A9',
                color: 'white'
              },
            }}>
            Cancel
          </Button>
          <Button
            onClick={handleLogout}
            autoFocus
            sx={{
              backgroundColor: theme.colors.orange,
              borderRadius: '5px',
              color: 'white',
              '&:hover': {
                backgroundColor: 'darkorange',
              },
            }}
          >
            Logout
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );

  return (
    <Box sx={{ display: "flex" }}>
      <AppBar
        position="fixed"
        sx={{
          display: { xs: "block", sm: "none", padding: 0 },
          background: theme.colors.orange,
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap>
            Admin Panel
          </Typography>
        </Toolbar>
      </AppBar>

      <Drawer
        variant="permanent"
        sx={{
          display: { xs: "none", sm: "block" },
          [`& .MuiDrawer-paper`]: {
            width: 240,
            boxSizing: "border-box",
            backgroundColor: theme.colors.orange,
            color: "#fff",
            padding: 0,
          },
        }}
        open
      >
        {drawerContent}
      </Drawer>

      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: "block", sm: "none" },
          [`& .MuiDrawer-paper`]: {
            width: 240,
            boxSizing: "border-box",
            backgroundColor: theme.colors.orange,
            color: "#fff",
          },
        }}
      >
        {drawerContent}
      </Drawer>
    </Box>
  );
};

export default Sidebar;
